import { render, staticRenderFns } from "./dictMange.vue?vue&type=template&id=ba544d0c&scoped=true&"
import script from "./dictMange.vue?vue&type=script&lang=js&"
export * from "./dictMange.vue?vue&type=script&lang=js&"
import style0 from "./dictMange.vue?vue&type=style&index=0&id=ba544d0c&scoped=true&lang=css&"
import style1 from "./dictMange.vue?vue&type=style&index=1&id=ba544d0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba544d0c",
  null
  
)

export default component.exports